export default "__VITE_ASSET__D5TGpE85__"